var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.47461,213.98975a116.52651,116.52651,0,0,0-74.73389-55.06446,68,68,0,1,0-51.48144,0,116.5263,116.5263,0,0,0-74.73242,55.062,4.00024,4.00024,0,1,0,6.9248,4.00684,108.03687,108.03687,0,0,1,187.09814.00147,4,4,0,0,0,6.92481-4.00586ZM68,96a60,60,0,1,1,60,60A60.06812,60.06812,0,0,1,68,96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3d1902b103d6f1719e9095cd8d93310c.svg";
export { ForwardRef as ReactComponent };